import { CreateChallengeForm } from "../components/create/CreateChallenge.fetcher";

export const CreateChallengePage = CreateChallengeForm;
